import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { APP_TITLE } from '../../constants/app.constants';

@Component({
  selector: 'app-title',
  imports: [],
  templateUrl: './app-title.component.html',
})
export class AppTitleComponent {
  envPrefix = environment.environmentLabel !== 'prod' ? `**${environment.environmentLabel.toLocaleUpperCase()}**` : '';
  prefixClass = environment.environmentColorClass ?? '';
  title = APP_TITLE;
}
